import { createContext } from 'react';

export type FilterType = {
  ipd: boolean;
  opd: boolean;
  healthCheckup: boolean;
  dental: boolean;
  maternity: boolean;
  vision: boolean;
};

export type FilterContextType = {
  filters: FilterType;
  updateFilters: (options: Partial<FilterType>) => void;
};

export const FilterContext = createContext<FilterContextType | undefined>(undefined);
